import React, { Component } from 'react'
import './Loader.css'

export default class Loader extends Component {
  render() {
    const { first_name, statusLabel } = this.props
    return (
    <div className='LoaderContainer'>
      <div className='LoaderBox'>
        <span className="loader"></span>
      </div>
      <div className='LoaderText'>{ first_name }, Estamos { statusLabel } tu pedido</div>
      <div className='LoaderText'>...</div>
    </div>
    )
  }
}
